(() => {
  const params = new URLSearchParams(window.location.search);
  const requestedKit = params.get('kit');

  if (!requestedKit || !['3', '5'].includes(requestedKit)) return;

  const targetText =
    requestedKit === '3'
      ? 'KIT 3 BÁSICAS FEMININAS'
      : 'KIT 5 BÁSICAS FEMININAS';

  let selected = false;

  function normalizeText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function findAndSelectOffer() {
    if (selected) return true;

    const allElements = Array.from(
      document.querySelectorAll(
        'div, article, section, label, button, [role="radio"]'
      )
    );

    const candidates = allElements.filter((element) => {
      const text = normalizeText(element.textContent);

      return text.includes(targetText);
    });

    if (!candidates.length) return false;

    /*
      Preferimos o menor container que ainda contém
      o título completo da oferta.
    */
    candidates.sort((a, b) => {
      return a.querySelectorAll('*').length - b.querySelectorAll('*').length;
    });

    for (const candidate of candidates) {
      /*
        1. Radio nativo dentro da oferta.
      */
      const radio = candidate.querySelector('input[type="radio"]');

      if (radio) {
        if (!radio.checked) {
          radio.click();

          radio.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }

        selected = true;
        scrollToBuilder();
        return true;
      }

      /*
        2. Elemento com role="radio".
      */
      const roleRadio =
        candidate.matches('[role="radio"]')
          ? candidate
          : candidate.querySelector('[role="radio"]');

      if (roleRadio) {
        roleRadio.click();

        selected = true;
        scrollToBuilder();
        return true;
      }

      /*
        3. Label clicável.
      */
      const label =
        candidate.matches('label')
          ? candidate
          : candidate.querySelector('label');

      if (label) {
        label.click();

        selected = true;
        scrollToBuilder();
        return true;
      }

      /*
        4. Botão dentro do card.
      */
      const button =
        candidate.matches('button')
          ? candidate
          : candidate.querySelector('button');

      if (button) {
        button.click();

        selected = true;
        scrollToBuilder();
        return true;
      }

      /*
        5. Último fallback:
        o próprio container pode ser clicável.
      */
      candidate.click();

      selected = true;
      scrollToBuilder();
      return true;
    }

    return false;
  }

  function scrollToBuilder() {
    const builder = document.getElementById('montar-kit');

    if (!builder) return;

    window.setTimeout(() => {
      builder.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 250);
  }

  /*
    Bundlex é carregado por app e pode aparecer depois
    do HTML inicial. Por isso tentamos imediatamente
    e também observamos alterações no DOM.
  */
  if (findAndSelectOffer()) return;

  const observer = new MutationObserver(() => {
    if (findAndSelectOffer()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
    Segurança para não deixar observer ativo eternamente.
  */
  window.setTimeout(() => {
    observer.disconnect();
  }, 10000);
})();